import { render } from "./ViewCourse.vue?vue&type=template&id=1f9179b9&scoped=true"
import script from "./ViewCourse.vue?vue&type=script&lang=js"
export * from "./ViewCourse.vue?vue&type=script&lang=js"

import "./ViewCourse.vue?vue&type=style&index=0&id=1f9179b9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.24_vue@3.5.24_webpack@5.102.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f9179b9"]])

export default __exports__